import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnChanges {
  @Input() newsList: any = [];
  constructor(private modal: CustomModalService) {}
  ngOnChanges(changes: SimpleChanges): void {
    this.newsList = changes['newsList']?.currentValue;
    this.mapHideShow();
  }

  ngOnInit(): void {
    this.mapHideShow();
  }

  trimString(text: string, length: number) {
    return text.length > length ? text.substring(0, length) + '...' : text;
  }
  mapHideShow() {
    this.newsList = this.newsList?.map((x: any) => ({
      ...x,
      showMore: false,
    }));
  }

  openAdditionalInfo(item: any) {
    item.showMore = !item.showMore;
    this.modal.invoke('AdditionalInfoNews', {
      initialState: {
        item,
        isFromDashboard: true,
      },
      class: 'modal-xl',
    });
  }
}
